import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CompanyEntity } from './company.entity';

@Index('fk_company__id', ['fkCompanyId'], {})
@Entity('company_goal')
export class CompanyGoalEntity extends BaseEntity {
	@Column('int', { name: 'fk_company__id', unsigned: true })
	public fkCompanyId!: number;

	@Column('smallint', { name: 'month', unsigned: true })
	public month!: number;

	@Column('smallint', { name: 'year', unsigned: true })
	public year!: number;

	@Column('int', { name: 'dailyCallDuration', unsigned: true })
	public dailyCallDuration!: number;

	@Column('int', { name: 'dailyCalls', unsigned: true })
	public dailyCalls!: number;

	@Column('int', { name: 'dailyCustomerVisits', unsigned: true })
	public dailyCustomerVisits!: number;

	@Column('int', { name: 'dailyCustomers', unsigned: true })
	public dailyCustomers!: number;

	@Column('int', { name: 'dailyLeadVisits', unsigned: true })
	public dailyLeadVisits!: number;

	@Column('int', { name: 'dailyLines', unsigned: true })
	public dailyLines!: number;

	@Column('int', { name: 'dailyProductiveCalls', unsigned: true })
	public dailyProductiveCalls!: number;

	@Column('int', { name: 'monthlyGP', unsigned: true })
	public monthlyGp!: number;

	@Column('int', { name: 'monthlyQuotes', unsigned: true })
	public monthlyQuotes!: number;

	@Column('int', { name: 'monthlyRevenue', unsigned: true })
	public monthlyRevenue!: number;

	@Column('decimal', {
		name: 'grossProfitMargin',
		nullable: true,
		precision: 5,
		scale: 2,
	})
	public grossProfitMargin!: string | null;

	@Column('int', { name: 'monthlyCustomersClosed', nullable: true })
	public monthlyCustomersClosed!: number | null;

	@Column('int', { name: 'monthlyCustomers', nullable: true })
	public monthlyCustomers!: number | null;

	@Column('decimal', {
		name: 'monthlyGrossProfitMargin',
		nullable: true,
		precision: 5,
		scale: 2,
	})
	public monthlyGrossProfitMargin!: string | null;

	@ManyToOne(() => CompanyEntity, (company) => company.companyGoals, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_company__id', referencedColumnName: 'id' }])
	public fkCompany!: CompanyEntity;
}
